import { render, staticRenderFns } from "./EmailMessageReplyBox.vue?vue&type=template&id=1c9badbf&scoped=true&"
import script from "./EmailMessageReplyBox.vue?vue&type=script&lang=js&"
export * from "./EmailMessageReplyBox.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessageReplyBox.vue?vue&type=style&index=0&id=1c9badbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9badbf",
  null
  
)

export default component.exports